import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCards";

export default function CategoryPage() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/articles", { params: { category: slug, limit: 30 } })
      .then(r => setItems(r.data.items))
      .finally(() => setLoading(false));
  }, [slug]);

  const label = slug.replace(/-/g, " ");
  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="category-page">
      <div className="overline text-sky-700 mb-2">Category</div>
      <h1 className="headline text-4xl md:text-5xl font-bold text-slate-900 mb-6 capitalize">{label}</h1>
      <p className="text-slate-600 max-w-2xl mb-10">Latest reporting and analysis from India's leading education newsroom on {label}.</p>
      {loading ? (
        <div className="text-slate-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="text-slate-500">No stories yet in this category.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a, i) => <ArticleCard key={a.id} article={a} tone={i % 2 ? "green" : "blue"} />)}
        </div>
      )}
    </div>
  );
}

export function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!q) return;
    setLoading(true);
    api.get("/articles", { params: { search: q, limit: 30 } })
      .then(r => setItems(r.data.items)).finally(() => setLoading(false));
  }, [q]);
  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="search-page">
      <div className="overline text-sky-700 mb-2">Search Results</div>
      <h1 className="headline text-3xl md:text-4xl font-bold text-slate-900 mb-6">Results for “{q}”</h1>
      {loading ? <div className="text-slate-500">Searching…</div> : items.length === 0 ? <div className="text-slate-500">No stories matched your search.</div> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">{items.map(a => <ArticleCard key={a.id} article={a} />)}</div>
      )}
    </div>
  );
}
